import {Tr} from "@/i18n/i18n";
import Container = Phaser.GameObjects.Container;
import Scene = Phaser.Scene;
import {Keys} from "@/constants/key";
import TextUtils from "@/utils/text-utils";
import {Fonts} from "@/constants/font";
import SoundUtils from "@/utils/sound-utils";
import SpriteUtils from "@/utils/sprite-utils";
import CU from "@/utils/c-u";


export class AddToSquadButton extends Container {

    constructor(scene: Scene, x: number, y: number, callback: () => void) {
        super(scene);
        this.x = x;
        this.y = y;

        let icon = SpriteUtils.addImage(this.scene!, 0, 0, Keys.ATLAS_UI, Keys.UI_BUTTON_ADD_TO_SQUAD);

        let titleText = TextUtils.addTextAdvanced(this.scene!, Tr('ne.uchastvuet.v.boju'), 0, -15,
            '#ffffff', 18, 'normal', 350, 'center', 2, Fonts.ARIAL_MT);

        let actionText = TextUtils.addTextAdvanced(this.scene!, Tr('vkljuchit.v.otrjad'), 0, 15,
            '#a4ff1a', 18, 'normal', 350, 'center', 2, Fonts.ARIAL_MT);

        let underline = scene.add.graphics();

        let thickness = 1;
        let color = Phaser.Display.Color.HexStringToColor('#a4ff1a').color;
        let alpha = 1;

        underline.lineStyle(thickness, color, alpha);

        underline.strokeRect(actionText.getBottomLeft().x!, actionText.y + 12, actionText.width, 1);

        let clickSound = SoundUtils.addSound(scene, Keys.SOUND_BUTTON_CLICK);

        icon.setInteractive().on('pointerup', () => {
            if (callback != null) {
                callback();
                SoundUtils.play(clickSound);
            }
        });

        this.add([icon, titleText, underline, actionText]);
    }

}
